import {create} from 'zustand';
import {TUserStore} from './types';
import {$api} from 'shared/api';
import {serializeParams} from 'shared/helpers/converters';
import {useApiariesStore} from 'entities/apiaries';

export const useUserStore = create<TUserStore>()((set, get) => ({
  userInfo: null,
  usersList: [],
  iAmAdmin: false,
  userNowDate: null,
  setUserNowDate: (date: Date): void => {
    set({userNowDate: date});
  },
  users: () => {
    const {usersList} = get();

    return usersList;
  },
  getUserInfo: async () => {
    const res = await $api.get('/users/me');
    set({userInfo: res.data});
  },
  getMyInfo: () => {
    const {userInfo} = get();

    return userInfo;
  },
  getUsers: async (phone, email) => {
    const res = await $api.get('/users', {
      params: {
        phone,
        email,
      },
      paramsSerializer: {serialize: serializeParams},
    });

    const usersList = res?.data?.items ?? [];

    set({
      usersList,
    });

    return usersList;
  },
  updateUser: async (params) => {
    const res = await $api.put(`/users/me`, params);
    set({userInfo: res.data});
    return res;
  },
  updateUserTz: async (params) => {
    const res = await $api.patch(`/users/me/timezone`, params);
    set({userInfo: res.data});
    return res;
  },
  updatePassword: async (params) => {
    const res = await $api.patch(`/users/me/password`, params);
    set({userInfo: res.data});
    return res;
  },
  setIAmAdmin: () => {
    const {userInfo, setIAmAdmin} = get();
    const currentApiary = useApiariesStore.getState().currentApiary();

    if (!currentApiary || !userInfo) {
      return setTimeout(() => {
        setIAmAdmin();
      }, 500);
    }

    set({
      iAmAdmin: userInfo.id === currentApiary.owner.id,
    });
  },
}));
